export function getHeightElement() {
  const getHeightElement =  document.querySelectorAll('.getHeight');
  if(getHeightElement){
    getHeightElement.forEach((item) => {
      item.setAttribute("style",  `--height:${item.getBoundingClientRect().height}px`)
      const closest = item.closest(".cinema-rental-custom") as HTMLDivElement;
      closest.classList.add("image")
    })
  }
}
const getHightestElementInList = (list: NodeListOf<Element>) =>{
  let highestHeight = 0;
  list.forEach((item) => {
    const height = item.getBoundingClientRect().height;
    if (height > highestHeight) {
      highestHeight = height;
    }
  })
  return highestHeight
}

export function setHighestElement() {
const getHeightElement =  document.querySelectorAll('.getHeight');
const txtAddress = document.querySelectorAll('.cinema-rental-footer .list .item .txt-address')
const high1 = getHightestElementInList(getHeightElement)
const highestElementTxt = getHightestElementInList(txtAddress)
getHeightElement.forEach((item) => {
  item.setAttribute("style",  `--height:${high1}px`)
})
txtAddress.forEach((item) => {
  item.setAttribute("style",  `--heightTxt:${highestElementTxt}px`)
})
}